import { Action } from "@ngrx/store";
import { IframePayload, IframeModal } from "@edp-pages/iframe/iframe.model";

export enum EIframeActions {
    SetIframe = "Set Iframe Url",
    ResetIframe = "Reset Iframe",
    ShowIframeModal  = "[Iframe] Show iframe modal"
}

export class SetIframe implements Action {
    public readonly type = EIframeActions.SetIframe;
    constructor(public payload: IframePayload, public preload = false, public reload = false) {}
}

export class ResetIframe implements Action {
    public readonly type = EIframeActions.ResetIframe;
    }

export class ShowIframeModal implements Action {
    public readonly type = EIframeActions.ShowIframeModal;
    constructor(public payload: IframeModal) {}
}

export type IframeActions = SetIframe | ShowIframeModal;
